import { useEffect } from 'react';
import { useRouter } from '@/i18n/navigation';

export interface BannerItem {
  uuid?: string;
  link?: string;
  has_activity_common_detail?: boolean;
}

/**
 * 获取 Banner 目标链接
 * @param item Banner 项
 * @returns 内部链接或 null(外部链接)
 */
export const getBannerLink = (item: BannerItem): string | null => {
  const { link, has_activity_common_detail, uuid } = item;

  // 外部链接返回 null
  if (link && /^https?:\/\//i.test(link)) {
    return null;
  }

  // 内部链接
  if (link) {
    return link;
  }

  // 通用活动详情页
  if (has_activity_common_detail && uuid) {
    return `/banner-detail?id=${uuid}&type=1`;
  }

  return null;
};

/**
 * 预加载 Banner 列表的 Hook
 * @param banners Banner 列表
 * @param options 配置选项
 */
export const usePrefetchBanners = (
  banners: BannerItem[],
  options: {
    enabled?: boolean;
  } = {}
) => {
  const { enabled = true } = options;
  const router = useRouter();

  useEffect(() => {
    if (!enabled || !banners || banners.length === 0) return;

    banners.forEach((item) => {
      const link = getBannerLink(item);
      if (link) {
        router.prefetch(link);
      }
    });
  }, [banners, enabled, router]);

  return { getBannerLink };
};
